import { type PlatformType } from '@cart-services/hooks/fp-b2b/store-map'
import { type CountryCode, type ProjectCode } from '@constants'
import { createContext, useMemo, type PropsWithChildren } from 'react'

type ThankyouContextProps = ThankyouProviderProps

export const ThankyouContext = createContext<ThankyouContextProps | null>(null)

export interface ThankyouProviderProps {
  projectCode: ProjectCode
  countryCode: CountryCode
  currency?: string
  campaignId: number
  platform: PlatformType
}

export const ThankyouProvider = (props: PropsWithChildren<ThankyouProviderProps>) => {
  const { children, projectCode, countryCode, currency, campaignId, platform } = props

  const contextValue = useMemo(
    () => ({
      projectCode,
      countryCode,
      currency,
      campaignId,
      platform,
    }),
    [currency, projectCode, countryCode, campaignId, platform],
  )

  return (
    <ThankyouContext.Provider value={contextValue}>
      {children}
    </ThankyouContext.Provider>
  )
}
